import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL, handleWhatsAppClick } from "../lib/site";

export const FloatingWhatsApp = () => {
    return (
        <a
            href={WHATSAPP_URL}
            onClick={handleWhatsAppClick}
            data-testid="floating-whatsapp"
            aria-label="Conversar no WhatsApp"
            className="fixed bottom-6 right-6 z-50 group"
        >
            <span aria-hidden className="absolute inset-0 rounded-full float-pulse" />
            <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#9f1e1e] text-[#F5F4F2] shadow-xl hover:scale-110 transition-transform duration-500">
                <MessageCircle className="w-6 h-6" strokeWidth={1.5} />
            </span>
            <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#2F2F2F] text-[#F5F4F2] text-xs px-3 py-2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Vamos conversar
            </span>
        </a>
    );
};
